import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { clearStoredAuth, getAuthState } from '../utils/auth';

export default function PrivateRoute({ children }) {
  const location = useLocation();
  const auth = getAuthState();

  if (!auth.authenticated) {
    clearStoredAuth();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
